<template>
	<!-- 待办流程 -->
	<div ref="tablePanel" style="padding:20px">
		<div class="head-search" ref="headSearch">
			<div class="search_left">
				<div class="item" v-for="(item,index) in tabList" :class="{active:isActive===index}" @click="checkTab(index)">
					<div :style="{background: item.color}" v-if="index>0">

					</div>
					{{item.text}}
				</div>
				<div>
					更多筛选
					<i class="el-icon-caret-bottom"></i>
				</div>
			</div>
			<div class="input">
				<el-input v-model="input" placeholder="请输入关键词搜索" prefix-icon="el-icon-search">
				</el-input>
				<i class="el-icon-s-grid" style="color: #9699a0;"></i>
				<i class="el-icon-s-unfold"></i>
			</div>
		</div>
		<div class="container">
			<div class="operation-btn" ref="operationBtn">
			</div>
			<div class="container-table">
				
				<el-table :style="{ height: `${tableMaxHeight}` + 'px' }" :max-height="tableMaxHeight" :data="tableData" v-if="type==0"
					stripe style="width: 100%" header-cell-class-name="tableHeaderCellClassName"
					header-row-class-name="tableHeaderRowClassName">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="name" label="单位名称"></el-table-column>
					<el-table-column prop="person" label="资质名称" width="120">
						<template slot-scope="scope">

						</template>
					</el-table-column>
					<el-table-column prop="type" label="申请等级" width="100"></el-table-column>
					<el-table-column prop="code" label="资质类别" width="130"></el-table-column>
					<el-table-column prop="address" label="状态" width="100" sortable></el-table-column>
					<el-table-column prop="time" label="登记时间" width="220"></el-table-column>
					<el-table-column prop="contact" label="登记人" width="120"></el-table-column>
					<el-table-column prop="number" label="业务类型" width="150"></el-table-column>
					<el-table-column label="操作" width='320'>
						<template v-slot="{ row }">
							<el-link icon="el-icon-printer" type="primary" :underline="false" class="cloumn-btn"
								@click="handleDetils">
								材料接收审查表
							</el-link>
							<el-link icon="el-icon-printer" type="primary" :underline="false" class="cloumn-btn">
								材料受理审查表
							</el-link>
							<el-link icon="el-icon-printer" type="primary" :underline="false" class="cloumn-btn">
								材料书面审查表
							</el-link>
							<el-link icon="el-icon-printer" type="primary" :underline="false" class="cloumn-btn">
								打印材料受理通知书
							</el-link>
						</template>
					</el-table-column>
				</el-table>
			
				<!-- 九宫格 -->
				
			</div>
			<div class="container-pagination" ref="containerPagination" v-if="type==0">
				<el-pagination background layout="prev, pager, next, sizes, jumper" :total="1000"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				input: '',
				tableMaxHeight: 400,
				isActive:0,
				type:1,
				tabList: [{
						text: '全部',
						color: ''
					},
					{
						text: '材料齐全',
						color: '#0147eb'
					},
					{
						text: '材料不齐全',
						color: '#f04444'
					},
					{
						text: '材料待处理',
						color: '#f7931a'
					},
					{
						text: '材料已补齐',
						color: '#8a3aed'
					},
					{
						text: '待受理',
						color: '#0147eb'
					},
					{
						text: '已受理',
						color: '#627eea'
					},
					{
						text: '待批准',
						color: '#44b4ad'
					},
					{
						text: '待发证',
						color: '#13b440'
					},
				],
				tableData: [{
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					}, {
						name: '腾杰广告有限公司',
						person: '印制资质',
						type: '甲级',
						code: '涉密文件资料',
						address: '材料齐全',
						time: '2022-08-23 05:21:19',
						contact: '孙子涵',
						number: '资质申请登记',
					},

				],
			}
		},
		mounted() {
			this.calcTableHeight()
			this.$root.$on('resize', () => {
				this.calcTableHeight(500)
			})
			this.editElPaginationJumperText()
		},
		methods: {
			handleAdd() {
				this.$refs.dialog.open()
			},
			handleEdit(row) {
				this.$refs.dialog.edit(row)
			},
			handleDetils() {
				this.$router.push({
					name: 'Detils'
				})
			},
			checkTab(val){
				this.isActive=val
			},
			editElPaginationJumperText() {
				document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue =
					'跳至'
			},
			calcTableHeight(delay) {
				// 动态计算表格的高度，自适应当前容器,168是计算得出的margin和padding的距离
				setTimeout(() => {
					const tablePanelHeight = this.$refs.tablePanel.parentNode.clientHeight
					const headSearchHeight = this.$refs.headSearch.clientHeight
					const operationBtnHeight = this.$refs.operationBtn.clientHeight
					const containerPaginationHeight = this.$refs.containerPagination.clientHeight
					this.tableMaxHeight =
						tablePanelHeight -
						headSearchHeight -
						operationBtnHeight -
						containerPaginationHeight -
						135
				}, delay || 0)
			},
		},
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-table__row .cell {
		font-family: Microsoft YaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 19px;
		letter-spacing: 0px;
		color: #24262b;
	}

	/deep/ .el-checkbox__inner {
		width: 20px;
		height: 20px;
		background-color: #ffffff;
		border-radius: 4px;
		border: solid 2px #c4c4c4;
	}

	/deep/ .el-checkbox__inner::after {
		left: 6px;
		top: 2px;
	}

	/deep/ .el-pagination__jump {
		margin-left: 0;
	}

	.head-search {
		width: 100%;
		height: 78px;
		background-color: #ffffff;
		box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
		border-radius: 16px;
		padding: 0 31px;
		box-sizing: border-box;
		// overflow: hidden;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.search_left {
			display: flex;
			align-items: center;
			.item {
				margin-top: 4px;
				line-height: 70px;
				margin-right: 32px;
				display: flex;
				align-items: center;
				border-bottom: #ffffff 4px solid;
				div {
					width: 14px;
					height: 14px;
					margin-right: 5px;
					border-radius: 50%;
				}
			}

			.active {
				
				border-bottom: #0147eb 4px solid;
			}
		}

		.input {
			width: 258px;
			height: 40px;
			border-radius: 4px;
			margin: 19px 0;
			margin-left: 24px;
			display: flex;
			align-items: center;
			i{
				font-size: 20px;
				margin-left: 10px;
			}
			
			/deep/ .el-input input,
			/deep/ .el-input-group__append {
				// background-color: #f1f1f1;
				border: none;
			}

			/deep/ .el-input {
				input {
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 19px;
					letter-spacing: 0px;
				}

				input::-webkit-input-placeholder {
					// 针对 谷歌 内核
					font-family: Microsoft YaHei;
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 19px;
					letter-spacing: 0px;
					// color: #c4c4c4;
				}

				input:-moz-placeholder {
					// 火狐
					font-family: Microsoft YaHei;
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 19px;
					letter-spacing: 0px;
					color: #c4c4c4;
				}

				input:-ms-input-placeholder {
					// 微软ie
					font-family: Microsoft YaHei;
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					line-height: 19px;
					letter-spacing: 0px;
					color: #c4c4c4;
				}
			}
		}
	}

	.container {
		width: 100%;
		// height: 858px;
		background-color: #ffffff;
		box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
		border-radius: 16px;
		margin-top: 16px;
		padding: 24px;
		box-sizing: border-box;

		.operation-btn {
			// margin-bottom: 24px;

			.btn {
				height: 40px;
				width: 96px;
			}

			.btn-plus {
				background-color: #0147eb;
			}

			.btn-delete {
				background-color: #f04444;
			}
		}

		/deep/ .tableHeaderCellClassName .cell {
			font-family: Microsoft YaHei;
			font-size: 14px;
			// font-weight: normal;
			font-stretch: normal;
			line-height: 22px;
			letter-spacing: 0px;
			color: #545454;
		}

		/deep/ .tableHeaderRowClassName th {
			background-color: #ebecf0;
			padding: 5px 0;
		}

		.cloumn-btn {
			width: 150px;
			height: 32px;
		}

		.container-pagination {
			display: flex;
			justify-content: end;
			margin-top: 26px;
		}
	}
</style>
